import React from 'react';
import {connect} from "react-redux";
import {Trans} from "react-i18next";
import BsPanelLoader from "components/panel/loader/BsPanelLoader";
import BsPanelHeader from "components/panel/header/BsPanelHeader";
import BsPanelHeaderFilters from "components/panel/header/BsPanelHeaderFilters";
import BsDataTable from "components/data-table/BsDataTable";
import BsPanelTitle from "components/panel/header/BsPanelTitle";
import BsTabPanel from "components/panel/BsTabPanel";
import SubscriptionPlansFilters from "./SubscriptionPlansFilters";
import SUBSCRIPTION_PLANS_TABLE from "./subscription-plans-table";
import Button from "@material-ui/core/Button";
import PlusIcon from "assets/img/plus.svg";
import {loadSubscriptionPlans} from "core/actions/subscription-plan-actions";

const queryString = require('query-string');

class SubscriptionPlans extends React.Component {

  constructor(props) {
    super(props);
    const query = queryString.parse(this.props.location.search);
    this.state = {
      sort: query.sort,
      direction: query.direction,
      fields: {
        name: query.name != null ? query.name : ''
      }
    };

    this.onLoadData(query);
  }

  onRequestSort = (params) => {
    this.setState({
      sort: params.sort,
      direction: params.direction
    });
    this.onLoadData(params);
  }

  handleChange(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({fields});
  }

  onHandleFilter = () => {
    const params = queryString.parse(this.props.location.search);
    params.name = this.state.fields.name;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
  }

  onHandleClear = () => {
    const params = queryString.parse(this.props.location.search);
    delete params.name;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
    this.setState({
      ...this.state,
      fields: {
        name: ''
      }
    })
  }

  onLoadData = (query) => {
    this.props.loadSubscriptionPlans(this.prepareQuery(query));
  }

  prepareQuery = (query) => {
    if (query.sort) {
      query.sort = query.sort + ',' + query.direction;
    }

    return query
  }

  onRowClick = (row) => {
    this.props.history.push('/global/subscription-plan/' + row.id + '/info')
  }

  onHandleAddPlan = (row) => {
    this.props.history.push('/global/add-subscription-plan')
  }

  render() {
    return (
        <BsTabPanel>
          <BsPanelLoader show={this.props.loading}/>
          <BsPanelHeader>
            <BsPanelTitle action={
              <Button variant="contained" color="primary" type="submit" onClick={this.onHandleAddPlan.bind(this)}>
                <PlusIcon/>&nbsp;<Trans i18nKey="general.add"/>
              </Button>
            }/>
          </BsPanelHeader>

          <BsPanelHeaderFilters onHandleFilter={this.onHandleFilter.bind(this)}
                                onHandleClear={this.onHandleClear.bind(this)}>
            <SubscriptionPlansFilters fields={this.state.fields}
                                      onHandleChange={this.handleChange.bind(this)}/>
          </BsPanelHeaderFilters>

          <BsDataTable location={this.props.location}
                       history={this.props.history}
                       order={this.state.direction}
                       orderBy={this.state.sort}
                       settings={SUBSCRIPTION_PLANS_TABLE}
                       content={this.props.subscriptionPlans}
                       onRowClick={this.onRowClick}
                       onChangePage={this.onLoadData}
                       onChangeSize={this.onLoadData}
                       onRequestSort={this.onRequestSort}/>
        </BsTabPanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    subscriptionPlans: state.subscriptionPlan.subscriptionPlans,
    loading: state.subscriptionPlan.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadSubscriptionPlans: (query) => {
      dispatch(loadSubscriptionPlans(query));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPlans);
